import React from 'react';
import { Controller } from 'react-hook-form';
import HookFormUtils from './HookFormUtils';
import MyTextField from '../MyTextField';

export default function HookFormSelect({
    control,
    schema,
    variant,
    loading,
    errors,
    label,
    prefix=null,
    children,
    ...others
}) {
    const error = HookFormUtils.getFieldError(errors, schema, prefix);
    const _schema = HookFormUtils.getSchemaName(schema, prefix);

    return (
        <Controller
            control={control}
            name={_schema}
            render={({ field: { onChange, value } }) => (
                <MyTextField onChange={onChange}
                             name={_schema}
                             value={value}
                             select
                             variant={variant || 'outlined'}
                             label={label}
                             error={error ? true : false}
                             helperText={error && error.message}
                             defaultValue={""}
                             {...others}>
                    {children}
                </MyTextField>
            )}
        />
    );
}